import { NavLink, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { supabase } from '../../utils/supabase';
import { setAdminViewMode } from '../../utils/adminViewMode';
import { useDashboard } from '../../contexts/DashboardContext';
import { useManagerHierarchyContext } from '../../contexts/ManagerHierarchyContext';
import ManagerAnalyticsSidebarNav from './ManagerAnalyticsSidebarNav';

function ManagerSidebar({ mobileOpen, onCloseMobile }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isGlobalUser } = useDashboard();
  const hierarchy = useManagerHierarchyContext();

  const isManager = location.pathname === '/manager';
  const showAnalyticsControl = isManager || (
    location.pathname.startsWith('/bootcamp/') && !!searchParams.get('client')
  );

  const handleLogout = async () => {
    try { await supabase.auth.signOut(); } catch {}
    navigate('/login', { replace: true });
  };

  const switchToGlobal = () => {
    setAdminViewMode('global');
    navigate('/admin/clients');
    onCloseMobile?.();
  };

  const navClass = ({ isActive }) =>
    `dashboard-nav-item${isActive ? ' dashboard-nav-item-active' : ''}`;

  return (
    <aside className={`dashboard-sidebar${showAnalyticsControl ? ' dashboard-sidebar-with-analytics' : ''}${mobileOpen ? ' dashboard-sidebar-open' : ''}`}>
      <div className="dashboard-sidebar-header">
        <div className="dashboard-brand">Propelion</div>
        <div className="dashboard-brand-sub">Manager</div>
      </div>

      <nav className="dashboard-nav">
        <NavLink
          to="/manager"
          className={navClass}
          isActive={() => isManager}
          onClick={(e) => {
            onCloseMobile?.();
            if (isManager && hierarchy.clientId) {
              e.preventDefault();
              hierarchy.setClient('');
            }
          }}
        >
          Analytics
        </NavLink>
        {showAnalyticsControl && <ManagerAnalyticsSidebarNav />}
      </nav>

      <div className="dashboard-sidebar-footer">
        {isGlobalUser && (
          <button type="button" className="dashboard-footer-btn" onClick={switchToGlobal}>
            Switch to Global View
          </button>
        )}
        <button type="button" className="dashboard-footer-btn dashboard-footer-btn-muted" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
}

export default ManagerSidebar;
